import * as React from 'react';

// components
import Forbidden from 'pages/Forbidden';

// stores
import { useStores } from 'index';
import { ApplicationUserRights } from 'stores/ApplicationUserRightsStore';

// types
import { Feature, License } from 'types/ProfileTypes';
import { IProfileStore } from 'stores/ProfileStore';

const isEmpty = (required?: unknown[] | unknown): boolean => required === undefined || (Array.isArray(required) && required.length === 0);

export const isUserAllowedToAccessPage = (
  profileStore: IProfileStore,
  requiredPermissions: string[] | string,
  requiredLicenses?: License[] | License,
  requiredFeatures?: Feature[] | Feature
) => {
  if (!ApplicationUserRights.IsAllowed(requiredPermissions)) {
    return false;
  }

  // A page that asks for no license or feature needs the permission only, so it doesn't depend on the license lookup.
  if (isEmpty(requiredLicenses) && isEmpty(requiredFeatures)) {
    return true;
  }

  return profileStore.HasAnyLicenseOf(requiredLicenses) || profileStore.HasAnyFeatureOf(requiredFeatures);
};

export const Authorization = (
  WrappedComponent: any,
  requiredPermissions: string[] | string,
  requiredLicenses?: License[] | License,
  requiredFeatures?: Feature[] | Feature
) => {
  const WithAuthorization: React.FC = (props) => {
    const { profileStore } = useStores();

    if (isUserAllowedToAccessPage(profileStore, requiredPermissions, requiredLicenses, requiredFeatures)) {
      return <WrappedComponent {...props} />;
    } else {
      return <Forbidden />;
    }
  };

  return WithAuthorization;
};
